import { yupObject, yupString } from '../../yup';
import { auStates, unaccreditedBrokerAggregators } from '@/helpers/const';
import type { State, UnaccreditedBrokerAggregatorEnum } from '@/api/enums';

const stateValues = Object.keys(auStates) as State[];
const aggregatorValues = Object.keys(unaccreditedBrokerAggregators) as UnaccreditedBrokerAggregatorEnum[];

export const unaccreditedBrokerSchema = () =>
  yupObject({
    firstName: yupString()
      .required()
      .test('len', 'Max characters input is 128', (val) => val.length <= 128)
      .label('First name'),
    lastName: yupString()
      .required()
      .test('len', 'Max characters input is 128', (val) => val.length <= 128)
      .label('Last name'),
    mobile: yupString()
      .matches(/^(\+\d{11,15}|04\d{8})$/, '${path} must be valid')
      .required()
      .label('Mobile number'),
    email: yupString().email().required().label('Email'),
    aggregator: yupString().oneOf(aggregatorValues).required().label('Aggregator'),
    state: yupString().oneOf(stateValues).required().label('State'),
  });
